<template>
  <v-main>
    <second-month-payment-banner v-if="banners.secondMonthPayment" />

    <div
      class="mt-3 tabs-container"
    >
      <!-- DEVELOPING ALERT -->
      <!-- <v-col
      cols="10"
      offset="1"
      lg="8"
      offset-lg="2"
      xl="4"
      offset-xl="4"
      class="mt-3"
    >
      <v-alert
        type="info"
        text
        color="primary"
        class="my-6"
      >
        {{ $t('home.comingSoon') }}
      </v-alert>
    </v-col> -->
      
      <!-- ВКЛАДКИ -->
      <div class="tabs-wrapper">
        <main-tabs />
        <router-view />
      </div>
    </div>
  </v-main>
</template>

<script>
import MainTabs from "@/components/MainTabs.vue"
import SecondMonthPaymentBanner from "@/components/banners/SecondMonthPaymentBanner";
import { mapGetters } from "vuex";

export default {
  name: 'Tabs',

  components: {
    MainTabs,
    SecondMonthPaymentBanner
  },

  computed: {
    ...mapGetters({
      banners: 'main/banners'
    })
  }
};
</script>

<style scoped>
  .tabs-container {
    display: flex;
    justify-content: center;
    padding: 12px;
  }

  .tabs-wrapper {
    display: flex;
    padding: 0 20px;
    justify-content: center;
    max-width: 100%;
  }
</style>